/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PraticaEventoPayload } from './pratica-evento-payload';


export interface ScoringManualOverridePayload extends PraticaEventoPayload { 
    valore_vecchio?: number;
    valore_nuovo?: number;
    punteggio_sportello_vecchio?: number;
    punteggio_sportello_nuovo?: number;
    motivo?: string;
    operatore_snapshot?: string;
}

